const openExternalUrl = (url: string) => window.open(url, '_blank', 'noopener,noreferrer');

const clearAllTimeouts = (timeoutIds: number[]) => {
  timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
};

export { openExternalUrl, clearAllTimeouts };
